import { motion } from "framer-motion";
import { ShieldCheck, Eye, Sprout } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const MISSION_IMAGE =
  "https://images.unsplash.com/photo-1776570380445-1a419559f603?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxjb21tdW5pdHklMjBzb2xpZGFyaXR5JTIwaG9sZGluZyUyMGhhbmRzfGVufDB8fHx8MTc3ODAwNTI2MXww&ixlib=rb-4.1.0&q=85";

const Mission = () => {
  const { t } = useLanguage();
  const icons = [ShieldCheck, Eye, Sprout];

  return (
    <section
      id="mission"
      className="py-24 md:py-32 bg-[#FDFBF7]"
      data-testid="mission-section"
    >
      <div className="container-narrow grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="lg:col-span-6"
        >
          <span className="eyebrow" data-testid="mission-eyebrow">{t.mission.eyebrow}</span>
          <span className="gold-line mt-4 mb-6" />
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-[#0A192F] leading-[1.1] font-medium" data-testid="mission-title">
            {t.mission.title}
          </h2>
          <p className="text-[#334155] text-base md:text-lg leading-relaxed mt-6" data-testid="mission-p1">
            {t.mission.p1}
          </p>
          <p className="text-[#334155] text-base md:text-lg leading-relaxed mt-4" data-testid="mission-p2">
            {t.mission.p2}
          </p>

          <div className="grid sm:grid-cols-3 gap-6 mt-10">
            {t.mission.values.map((v, i) => {
              const Icon = icons[i] || ShieldCheck;
              return (
                <div
                  key={v.title}
                  className="border-l-2 border-[#C5A059] pl-4"
                  data-testid={`mission-value-${i}`}
                >
                  <Icon size={20} className="text-[#C5A059] mb-2" />
                  <h3 className="font-serif text-xl text-[#002B49] mb-1.5 font-semibold">
                    {v.title}
                  </h3>
                  <p className="text-sm text-[#64748B] leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.97 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-6 relative"
        >
          <div className="relative rounded-2xl overflow-hidden aspect-[4/5] shadow-[0_20px_60px_-20px_rgba(0,43,73,0.35)]">
            <img
              src={MISSION_IMAGE}
              alt="Communauté solidaire"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-white rounded-xl shadow-xl p-5 max-w-xs hidden md:block">
            <div className="font-serif text-3xl text-[#C5A059] font-semibold">2014</div>
            <div className="text-sm text-[#64748B] mt-1">
              Fondation reconnue d'utilité publique
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Mission;
